import React from "react";
import Spinner from "@cc/react-components/Spinner";

interface Props {
  /** An additional message to display under the loading icon **/
  message?: string;
}

const LoadingScreen = ({ message }: Props) => {
  return (
    <div className="h-100 d-flex flex-column align-items-center justify-content-center">
      <Spinner animation="brand" size="lg" />
      {message && <h3 className="mt-3">{message}</h3>}
    </div>
  );
};

export default LoadingScreen;
